import { useQuery } from 'react-query';

import { Category } from '../../../types/Category';
import { PaginatedList } from '../../../types/PaginatedList';
import Api from '../../api/api';

export const getSubCategoriesByPage = async (page: number, sort: string, search?: string): Promise<PaginatedList<Category>> => {
  const [response, bodyOrError] = await Api.get(`sub-categories`, {
    page,
    sort,
    search,
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetSubCategoriesByPage = ({ page, sort, search = '' }: { page: number; sort: string; search?: string }) =>
  useQuery(['getSubCategoriesByPage', page, sort, search], () => getSubCategoriesByPage(page, sort, search), {
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
